import React, { createContext, useMemo, useContext } from 'react';
import Radio from './Radio.js';
import { Group, ErrorMessage } from './styles.js';

var RadioGroupContext = createContext(null);
var RadioGroup = function (_a) {
    var name = _a.name, onChange = _a.onChange, selectedRadio = _a.selectedRadio, readOnly = _a.readOnly, inline = _a.inline, errorMessage = _a.errorMessage, children = _a.children;
    var value = useMemo(function () { return ({
        name: name,
        onChange: onChange,
        selectedRadio: selectedRadio,
        readOnly: readOnly,
    }); }, [name, onChange, selectedRadio, readOnly]);
    return (React.createElement("div", null,
        React.createElement(RadioGroupContext.Provider, { value: value },
            React.createElement(Group, { inline: inline }, children),
            errorMessage && (React.createElement(ErrorMessage, { type: "default" }, errorMessage)))));
};
var useRadio = function () {
    var context = useContext(RadioGroupContext);
    if (!context) {
        throw new Error('useRadio must be used within RadioGroupContext provider');
    }
    return context;
};
RadioGroup.Radio = Radio;

export { RadioGroup as default, useRadio };
